<template>
    <form @submit.prevent="submit" @keydown="errors.clear($event.target.name)">

        <base-input class="mb-3"
            :label="$t('common.name')"
            :placeholder="$t('common.name')"
            required
            v-model="value.name"
            name="name"
            :error="errors.get('name')">
        </base-input>

        
        <div class="mt-4 mb-4">
            <h4 class="card-title mb-2">{{ $t('common.permissions') }}</h4>

            <div v-for="(permissionGroup, groupKey) in permissions" :key="groupKey">
                <base-checkbox v-for="(permission, key) in permissionGroup.permissions" :key="key"
                    v-model="value.permissions[key]">

                    {{ permission.name }}
                </base-checkbox>
            </div>
        </div>

        <div class="category form-category mb-3">* {{ $t('common.required-fields') }}</div>

        <div class="buttons pt-2 text-center">
            <base-button type="primary" native-type="submit" :disabled="errors.any()">
                {{ value.id ? $t('common.update') : $t('common.create') }}
            </base-button>

            <button type="button" class="btn btn-secondary" data-dismiss="modal">
                {{ $t('common.cancel') }}
            </button>
        </div>

    </form>
</template>

<script>
    export default {
        props: ['value', 'errors', 'permissions'],
        methods: {
            submit() {
                this.$emit('input', { ...this.value})
            }
        }
    }
</script>
